var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tempData flex alignCenter spacearound"},[_c('div',{staticClass:"flex flexColumn alignCenter",staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"300px","height":"300px"},attrs:{"src":require("@/assets/img/common/tempData.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.shouwtext)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }